import React from 'react';
import { Helmet } from 'react-helmet-async';
import { LOGO_URL } from '../data/mock';

export const SITE_URL = 'https://compareyouroptions.com.au';
export const SITE_NAME = 'CompareYourOptions.com.au';

// Reusable SEO head: title, meta description, canonical, Open Graph, Twitter cards
// and optional JSON-LD structured data (single object or array).
export const Seo = ({ title, description, path = '', image, type = 'website', jsonLd }) => {
  const url = `${SITE_URL}${path}`;
  const img = image || LOGO_URL;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
};
